import Colors from '../../styles/colors';

const styles = (theme) => ({
    wrapper: {
        position: 'fixed',
        top: 0,
        zIndex: 2,
        backgroundColor: Colors.red,
        width: '100%',
    },
    shareBtn: {
        height: 50,
        borderRadius: 50,
        backgroundColor: Colors.blue,
        padding: '10px 25px',
        display: 'flex',
        flexDirection: 'row',
        '&:hover, &:focus': {
            backgroundColor: Colors.white,
            border: `2px solid ${Colors.blue}`,
            padding: '8px 23px',
        },
    },
    donateBtn: {
        height: 50,
        borderRadius: 50,
        backgroundColor: Colors.white,
        padding: '10px 25px',
        marginLeft: 10,
        display: 'flex',
        flexDirection: 'row',
        '&:hover, &:focus': {
            backgroundColor: Colors.blue,
            border: `2px solid ${Colors.white}`,
            padding: '8px 23px',
        },
    },
    donateIcon: {
        '& svg': {
            verticalAlign: 'baseline',
            paddingRight: 5,
        },
    },
    donateTxt: {
        fontFamily: 'chaneyregular, sans-serif',
        alignSelf: 'center',
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    shareIcon: {},
    shareTxt: {
        fontFamily: 'chaneyregular, sans-serif',
        fontSize: 16,
        paddingLeft: 10,
        lineHeight: '1em',
        textAlign: 'left',
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    logoImg: {
        height: 70,
        marginTop: 15,
        marginBottom: 15,
        [theme.breakpoints.down('sm')]: {
            height: 50,
        },
    },
    // Modal content
    modalTitle: {
        color: Colors.white,
        fontFamily: theme.typography.h1.fontFamily,
        fontSize: 40,
        lineHeight: '1em',
        [theme.breakpoints.down('sm')]: {
            fontSize: 26,
        },
    },
    modalTitleHighlight: {
        color: Colors.red,
    },
    modalCloseBtn: {
        color: Colors.white,
        '& svg': {
            width: '2em',
            height: '2em',
        },
        [theme.breakpoints.down('sm')]: {
            padding: 3,
            '& svg': {
                width: '1em',
                height: '1em',
            },
        },
    },
    socialBlock: {
        width: 80,
        height: 80,
        backgroundColor: Colors.black,
        padding: 20,
        display: 'inline-flex',
        border: `2px solid ${Colors.white}`,
        borderRight: 0,
        '&:last-child': {
            borderRight: `2px solid ${Colors.white}`,
        },
        '& svg': {
            color: Colors.white,
        },
        '&:hover': {
            backgroundColor: Colors.white,
            '& svg': {
                color: Colors.black,
            },
        },
        [theme.breakpoints.down('sm')]: {
            width: 60,
            height: 60,
            padding: 10,
        },
    },
    instaHint: {
        color: Colors.white,
        opacity: 0.7,
        paddingTop: 15,
    },
    modalWrapper: {
        '&:focus': {
            outline: 0,
        },
        height: '100vh',
    },
    modalRoot: {
        backgroundColor: `${Colors.black} !important`,
    },
});
export default styles;
